module.exports = __webpack_public_path__ + "static/media/ss.71c63d60.svg";